import React from 'react';
import './Loading.css';

const Loading = () => {
  return (
    <>
        <h1 className="h1 text-[30px] font-extrabold text-[red!important]">Loading...</h1>
        <div className="loader"></div>
    </>
  )
}

export default Loading;